import * as Sentry from '@sentry/react';
import { FetchError } from 'ofetch';
import { IS_PRERENDERING, MODE, SENTRY_DSN, VERSION } from '@/base/constants';

export const initiateSentry = () => {
  if (!SENTRY_DSN || IS_PRERENDERING) return;
  Sentry.init({
    dsn: SENTRY_DSN,
    release: VERSION,
    environment: MODE,
    ignoreErrors: [
      'OneSignal',
      'Service worker ready timeout',
      /serviceWorker/,
    ],
    beforeSend(event, hint) {
      const error = hint?.originalException;
      if (
        error instanceof FetchError &&
        error.status &&
        error.status >= 400 &&
        error.status < 500
      ) {
        return null;
      }
      return event;
    },
  });
};
